import axiosCommonApi from '@apis/axiosCommonApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'


//  đơn vềEtính giá vốn
export function getListUnit(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosCommonApi.get('/sanpham/get-all-donvitinh', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


//  đơn vềEkahi báo
export function getListUnitReport(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosCommonApi.get('/sanpham/get-all-donvikhaibao', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

//  đặc thù hàng
export function getListCategorie(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosCommonApi.get('/sanpham/get-all-dacthuhang', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


//  đặc thù hàng
export function getListWareHouse(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosCommonApi.get('/yeucaumua/get-all-kho', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function uploadImage(image: any) {
  let formData = new FormData();    //formdata object

  formData.append('image', image);   //append the values with key, value pair
  try {
    // Dùng axiosCommonApi (đã có access_nhansu_token)
    return axiosCommonApi.post('/chung/tai-len-hinh', formData)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}





